import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SelfAssessmentEnhancementComponent } from './self-assessment-enhancement/self-assessment-enhancement.component';
import { SelfAssessmentDashboardComponent } from './self-assessment-dashboard/self-assessment-dashboard.component';
import { AssessmentDetailsComponent } from './assessment-details/assessment-details.component';
import { SelfAssessmentGapComponent } from './self-assessment-gap/self-assessment-gap.component';
import { SelfAssessmentSummaryComponent } from './self-assessment-summary/self-assessment-summary.component';
import { SelfAssessmentComponent } from './self-assessment.component';
import { SelfAssessmentT2DetailsComponent } from '../self-assessment-template2/self-assessment-t2-details/self-assessment-t2-details.component';
import { SelfAssessmentDashboard2Component } from './self-assessment-dashboard2/self-assessment-dashboard2.component';
import { SelfAssessmentDashboard3Component } from './self-assessment-dashboard3/self-assessment-dashboard3.component';

export const selfAssessmentRoutes: Routes = [
  {
    path: '',
    component: SelfAssessmentComponent,
    children: [
      {
        path: 'summary',
        component: SelfAssessmentSummaryComponent,
      },
      {
        path: 'gaps',
        component: SelfAssessmentGapComponent,
      },
      {
        path: 'details/:filter/:id',
        component: AssessmentDetailsComponent,
      },
      {
        path: 'dashboard',
        component: SelfAssessmentDashboardComponent,
      },
      {
        path: 'dashboard2',
        component: SelfAssessmentDashboard2Component,
      },
      {
        path: 'dashboard3',
        component: SelfAssessmentDashboard3Component,
      },
      {
        path: 'enhancements',
        component: SelfAssessmentEnhancementComponent,
      },
      // {
      //   path: 'details/:filter/:param1/:id',
      //   component: SelfAssessmentT2DetailsComponent,
      // }
    ],
  },
];

// @NgModule({
//   imports: [RouterModule.forChild(selfAssessmentRoutes)],
//   exports: [RouterModule],
// })
// export class SelfAssessmentRoutingModule {}
